import React from 'react';
import {
	type JSErrorBoundaryProps,
	JSErrorBoundary,
} from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';

export const ContextMenuErrorBoundary = ({
	id,
	children,
	fallback,
}: Partial<JSErrorBoundaryProps> & { id: string }) => (
	<JSErrorBoundary
		id={id}
		packageName="jiraSoftwareContextMenu"
		fallback={fallback || 'unmount'}
		teamName="deliveroo"
	>
		{children}
	</JSErrorBoundary>
);
